import ScrollBar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';

export default function Groups({ children }) {
    return (
        <ScrollBar>
            <div className="sidebar-body flex-grow-1">
                <ul className="user-list d-flex flex-column">
                    {children}
                </ul>
            </div>
        </ScrollBar>
    );
}
